import { Controller } from "@hotwired/stimulus"

// Initializes a Bootstrap tooltip on the element it's attached to.
//
// Usage:
//   <i data-controller="tooltip" data-bs-toggle="tooltip"
//      data-bs-title="line 1<br>line 2" data-bs-html="true"></i>
//
// Bootstrap is exposed globally as window.bootstrap (see application.js). The
// guard keeps this a no-op (native title still shows) if Bootstrap JS isn't
// loaded for some reason.
export default class extends Controller {
  connect() {
    if (window.bootstrap?.Tooltip) {
      this.tooltip = new window.bootstrap.Tooltip(this.element)
    }
  }

  disconnect() {
    this.tooltip?.dispose()
  }
}
